import services from './../../../services/service'; // Service Class
import MainHeader from './../../MainHeader/index.vue'; // Main Header
import MainFooter from './../../MainFooter/index.vue'; // Main Footer
import NewProductGallery from '../../../components/posts/newproductgallery.vue'

import ProductForm from '../../../components/product/ProductForm.vue'
import ProductItemForm from '../../../components/product/ProductItemForm.vue'
import ProductCartActions from '../../../components/product/ProductCartActions.vue'
import ProductCTAActions from '../../../components/product/ProductCTAActions.vue'

import MenuLeftBar from '../../../components/menuleftbar.vue'
let service = new services();

export default {
    name: 'Product',
    props: ['productItem'],
    data () {
        return {
            user: {},
            loggedIn: false,
            cart: this.$store.state.cart,
            sellpoint: {},
            gallery:{},
            post:{},
            display_post:{},
            details:{},
            reviews:{},
            information: {},
            states:{},
            cities:{},
            other_products:{},
            delivery_option:{},
            discount_coupon:{},
            product_item: {},
            sellpoint_categories:{},
            seller_mode:false,
            can_edit: false,
            edit_mode:false,
            disable_btn: false,
            setPanel: false,
            other_delivery_option:false,
            edit_other_delivery_option:false,
            edit_city:false,
            editGalleryPanel: false,
            viewGalleryPost: false,
            editGalleryPostPanel: false,
            removeGalleryPanel:false,
            removeGalleryPostPanel:false,
            product_details_descr:true, //default view
            product_details_reviews: false,
            product_details_information: false,
            addDeliveryInformation:false,
            editDeliveryInformation:false,
            setDiscount:false,
            editDiscount:false,
            img_product_url: service.imageProductsURL,
            img_user_url: service.imageUsersURL,
            siteUrl:"",
            is_product_in_cart: false,
            loading:false,
            action_loading:false,
            copied: false,
            descr_active: 'active',
            user_type:"buyer",
            new_added: false,
            product_display_image:{},

            //
            addNewPost: false,
            imageForm: "",
            file_info: {}
        }
    },
    components: {
        'component-header': MainHeader,
        'component-footer': MainFooter,
        'product-gallery-form': NewProductGallery,
        // "product-item-form": ProductItemForm,
        // 'add-to-cart-button': ProductCartActions,
        // 'product-cta-button': ProductCTAActions,
        'menu-left-bar': MenuLeftBar,
   
    },
    methods: {
        redir(rlink){
            location.replace("/"+rlink)
        },
        copyLink() {
            this.$clipboard(this.siteUrl)
            this.copied = true;
        },
        mobileSideNavToggle(action){
            if(action == "open"){
                document.getElementById("mobileSideNav").style.width = "300px";
            }
            if(action == "close"){
                document.getElementById("mobileSideNav").style.width = "0";
            }
        },

        activate_processing(){
            this.disable_btn = true;
            this.action_loading = true;
        },

        deactivate_processing(){
            this.disable_btn = false;
            this.action_loading = false;
        },
        
        setComponent(attr1,attr2){
            this.setPanel = true;
            
            if(attr1 == 'add-new-post'){
                this.addNewPost = true;
            }
            if(attr1 == 'edit-gallery'){
                this.editGalleryPanel = true;
            }
            if(attr1 == 'remove-gallery'){
                this.removeGalleryPanel = true;
            }
            if(attr1 == 'view-gallery-post'){
                this.viewGalleryPost = true;
                this.display_post = attr2;
            }
            if(attr1 == 'close-view-gallery-post'){
                this.viewGalleryPost = false;
            }
            if(attr1 == 'edit-gallery-post'){
                this.editGalleryPostPanel = true;
            }
            if(attr1 == 'remove-gallery-post'){
                this.removeGalleryPostPanel = true;
            }
            if(attr1 == 'edit-product-detail'){
                this.details.edit_product_detail = false;
                this.details = attr2;
                this.details.edit_product_detail = true;
            }
            if(attr1 == 'edit-product-delivery'){
                this.details.edit_product_delivery = false;
                this.details = {};
                this.details.edit_product_delivery = true;
            }
            if(attr1 == 'add-delivery-option'){
                this.addDeliveryInformation = true;
            }
            if(attr1 == 'edit-delivery-option'){
                this.delivery_option.edit_set = false;
                this.editDeliveryInformation = true;
                this.delivery_option = attr2;
                this.delivery_option.edit_set = true;
                //prepare city data
                this.getCities(this.delivery_option.business_delivery_state,'edit'); //option edit
            }
            if(attr1 == 'set-product-item'){
                this.product_item = attr2;
            }
            if(attr1 == 'set-product-display-image'){
                this.product_display_image = attr2;
            }
            if(attr1 == 'set-descr'){
               // console.log(location.href);
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails',''));
               // location.replace(location.href.replace('#productDetails',''))
                this.product_details_descr = true;
                this.product_details_reviews = false;
                this.product_details_information = false;
                window.location.hash = "";
            }
            if(attr1 == 'set-reviews'){
                window.location.hash = "productDetails";
                history.pushState({}, null, location.href.replace('#productDetails','')); //refresh url to allow next click
                this.descr_active = '';
                this.product_details_reviews = true;
                this.product_details_descr = false;
                this.product_details_information = false;
            }
            if(attr1 == 'set-information'){
                this.descr_active = '';
                this.product_details_information = true;
                this.product_details_reviews = false;
                this.product_details_descr = false;
            }
            if(attr1 == 'set-discount'){
                this.setDiscount = true;
                this.editDiscount = false;
            }
            if(attr1 == 'edit-discount'){
                this.editDiscount = true;
                this.setDiscount = false;
                this.discount_coupon = attr2;
            }
            if(attr1 == 'reset-edit'){
                this.editGalleryPanel = false;
                this.editGalleryIPostPanel = false;
                this.removeGalleryPanel = false;
                this.removeGalleryPostPanel = false;
                this.addDeliveryInformation = false;
                this.editDeliveryInformation = false;
                this.delivery_option.edit_set = false;
                this.setDiscounts = false;
                this.editDiscount = false
            }
        },

        

        checkIfVideo(url){
            let ext = url.split('.').pop();
            if(service.video_exts.includes(ext)){
                return true;
            }else{
                return false;
            }
        },
        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("sp_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                      let data = response.body.data;
                        data.forEach(function(element) {
                            this.user.user_id = element.user_id;
                            this.user.user_name = localStorage.getItem("sp_user");
                            this.sellpoint.business_id = this.gallery.gallery_posts_group_point_id;
                            //set seller options
                            this.is_editing();
                            //loggedIn options
                            this.loggedIn = true;
                        }, this);
                    }else {
                       //this.$router.push('login');
                      }
                }).catch((err) => {
                    if(err) {
                        //this.$router.push('login');
                    }
                })
            }else {
               //this.$router.push('login');
            }
        },

        is_editing(){ //preseting if seller
            var payload = {
                validate_user: this.user.user_id,
                validate_business: this.sellpoint.business_id
            }
            service.can_edit(this, payload).then(response => {
                if(response.body.status == 200) {
                    this.seller_mode = true;  //important
                    this.edit_mode =  true;
                    this.can_edit = true;
                }else {
                    this.edit_mode =  false;
                    this.seller_mode = false;  //important
                }
            }).catch((err) => {
                if(err) {
                    //log error
                }
            })
        },

        switchMode(){
            if(this.edit_mode == false){
                this.is_editing(); //revalidate seller
            }else{
                this.edit_mode = false;
                this.can_edit = true;
            }
        },

       

        setGallery(){
            this.loading = true;
            service.getGallerySearch(this, this.$route.params.idg).then(response => {
                if(response.body.status == 200) {
                    this.gallery = response.body.data;
                    if(this.gallery.gallery_posts_group_posts.length > 0){
                        this.display_post = this.gallery.gallery_posts_group_posts[0];
                    }
                   
                    document.title = this.gallery.gallery_posts_group_name + " | " +this.gallery.gallery_posts_group_ownername+ " | SP";

                    // this.gallery_display_image = this.gallery.gallery_images[0];
                   
                    // this.siteUrl = service.siteUrl+"?p="+this.product.product_url_name
                    // +"&p1="+this.product.product_business_ownername
                    // +"&p2="+this.product.product_url_name
                    // +"&p3="+encodeURI(this.product.product_name)
                    // +"&p4="+encodeURI(this.product.product_description)
                    // +"&p5="+this.product_item.product_item_image
                    // +" ";

                    
                    // this.product.product_share_url = "http://sellpoints.com.ng/"+this.product.product_business_ownername+"/"+this.product.product_url_name;
                    //
                    this.preset();
                    //set other products
                    // this.setOtherProducts(this.product.product_business_id);
                    //set sellpoint categories
                    // this.getSellpointCategories();
                    //check if already added to cart
                    // this.check_in_cart()
                    this.loading = false;
                }else{
                    // this.redir(this.$route.params.id); //go to sellpoint
                }
            }).catch((err) => {
            //    console.log(err)
              // this.redir(this.$route.params.id); //go to sellpoint
                //log it
                //location.replace("/")
            })
        },

        
        addPostToGallery(){
            this.disable_btn = true;
            //this.business.agree = true;
            var credentials = {
                gallery_new_group: false,
                gallery_post_group: this.gallery.gallery_posts_group_id, 
                gallery_post_caption: this.post.post_caption || "nill",
                gallery_post_details: this.post.post_details,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_details != undefined) {
                service.addGallery(this, credentials).then(function(data) {
                    if(data.body.status == 201) {
                        toastr.success("Post Created", 'Success!');
                        //log user in
                        this.post = data.body.data;
                        
                        //add image
                        //let result = data.body.data;
                        this.imageForm.append("data_id", this.post.post_id);
                        this.imageForm.append("data_type","gallery_media");
                        service.uploadDataPhoto(this, this.imageForm).then(data => {
                        if(data.body.status == 200){
                            //this.product.product_image = data.body.data;
                            // location.reload(true);
                           // this.product_info = true;
                           this.setGallery();
                           this.gallery = data.body.data_gallery;
                           this.addNewPost = false;
                           this.edit_mode = false;
                            //this.product_url = "/"+this.$route.params.id+"/"+this.product.product_url_name;
                        }
                        }).catch((err) => {
                                if(err) {
                                // log it
                                console.log(err)
                                }
                            toastr.warning("Something went wrong.", 'Warning!');
                        })

                        //navi.push("/"+this.$route.params.id+"/"+this.product.product_url_name); //changed for now, info on banner

                        
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                        this.disable_btn = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        editGallery(){
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_group_name: this.gallery.gallery_posts_group_name,
                gallery_group_description:this.gallery.gallery_posts_group_text,
                gallery_group_point: this.sellpoint.business_id,
            }
          
            let navi = this.$router;
            if(credentials.gallery_group_name != undefined) {
                service.editGallery(this, this.gallery.gallery_posts_group_id, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        toastr.success("Lookbook Edited", 'Success!');
                        //log user in
                       // this.gallery = data.body.data;
                        this.deactivate_processing();
                        this.editGalleryPanel = false;

                        //reroute since name might be affected
                       navi.push('/'+this.$route.params.id+'/g/'+data.body.data_gallery_posts_group_url_name)
                    //    window.history.pushState({}, null, '/'+this.$route.params.id+'/g/'+data.body.data_gallery_posts_group_url_name);
                   }else{
                    this.deactivate_processing();
                    this.editGalleryPanel = false;
                   }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                       this.deactivate_processing();
                       this.editGalleryPanel = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        removeGallery(){
            this.activate_processing();
            let navi = this.$router;
            service.deleteGallery(this, this.gallery.gallery_posts_group_id).then(function(data) {
                if(data.body.status == 200) {
                   //return to sellpoint
                   location.replace('/'+this.$route.params.id); //go to sellpoint
                }else{
                    toastr.warning("Something went wrong", 'Warning!'); 
                    this.deactivate_processing();
                    this.removeGalleryPanel =  false;
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.removeGalleryPanel =  false;
                    toastr.warning("Something went wrong", 'Warning!'); 
                   // console.log(err)
                    // this.disable_btn = false;
                }
            })
        },

        
        editGalleryPost(){
            this.activate_processing();
            //this.business.agree = true;
            var credentials = {
                gallery_post_caption: this.display_post.gallery_post_caption,
                gallery_post_details:this.display_post.gallery_post_details,
                gallery_post_group: this.gallery.gallery_posts_group_id,
            }
          
            let navi = this.$router;
            if(credentials.gallery_post_caption != undefined) {
                service.editGalleryPost(this, this.display_post.gallery_post_id, credentials).then(function(data) {
                    if(data.body.status == 200) {
                        toastr.success("Lookbook Post Edited", 'Success!');
                        //log user in
                       // this.gallery = data.body.data;
                        this.deactivate_processing();
                        this.editGalleryPostPanel = false;
                        this.gallery = data.body.data; //refresh data
                   }else{
                    this.deactivate_processing();
                    this.editGalleryPostPanel = false;
                   }
                }).catch((err) => {
                    if(err) {
                        toastr.warning("Something went wrong", 'Warning!'); 
                       // console.log(err)
                       this.deactivate_processing();
                       this.editGalleryPostPanel = false;
                    }
                })
            }else {
                toastr.error('Kindly fill all fields', 'Warning!');
                this.disable_btn = false;
            }
        },

        removeGalleryPost(){
            this.activate_processing();
            let navi = this.$router;
            service.deleteGalleryPost(this, this.display_post.gallery_post_id).then(function(data) {
                if(data.body.status == 200) {
                    this.gallery = data.body.data; //refresh data
                    this.deactivate_processing();
                    this.removeGalleryPostPanel =  false;
                    this.viewGalleryPost = false;
                }else{
                    toastr.warning("Something went wrong", 'Warning!'); 
                    this.deactivate_processing();
                    this.removeGalleryPostPanel =  false;
                }
            }).catch((err) => {
                if(err) {
                    this.deactivate_processing();
                    this.removeGalleryPostPanel =  false;
                    toastr.warning("Something went wrong", 'Warning!'); 
                   // console.log(err)
                    // this.disable_btn = false;
                }
            })
        },

        deletePostImage(image){
            this.activate_processing();
            var payload = {
                data_type: "gallery_media",
            }
            service.deleteImages(this, image, payload).then(function(data) {
                if(data.body.status == 200) {
                    this.setGallery();
                    this.deactivate_processing();
                }
            }).catch((err) => {})
        },
   

        //uploads
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {   
                this.file_info = files;
                let formData = new FormData();
                formData.append('photo', files[0]); 
                this.imageForm = formData;
            }   
        
        },
       
        //uploads for adding media to gallery post
        onFileChange2(e,type,data_id) {
            this.activate_processing();
            let files = e.target.files || e.dataTransfer.files;
            if (files.length)
            {
                let formData = new FormData();
                formData.append('photo', files[0]);
                formData.append('data_id', data_id);
                formData.append('data_type', type);  
                
                this.imageForm = formData;
                service.uploadDataPhoto(this, formData).then(data => {
                    if(data.body.status == 200){
                        if(type == "gallery_media"){
                            this.setGallery();
                           
                        }
                    }
                    this.deactivate_processing();
                }).catch((err) => {
                    if(err) {
                        // log it
                    }
                })
            }   
                
        },
        



        

        //categories settings
        getSellpointCategories(){
            service.getBusinessByUserName(this, this.product.product_business_ownername).then(response => {
                if(response.body.status == 200) {
                   let sellpoint = response.body.data;
                   service.getBusinessCategories(this, sellpoint.business_id).then(response => {
                        if(response.body.status == 200) {
                            this.sellpoint_categories = response.body.data;
                        }
                    }).catch((err) => {})
                }
            }).catch((err) => {
                //log it
                //this.$router.push("/")
                //console.log(err)
            })

        },


},
mounted:function(){
    var top = document.getElementById("wrap").offsetTop; 
    window.scrollTo(0, top); 
},
created: function(){
    

    this.setGallery();
    
}
}


// WEBPACK FOOTER //
// ./src/pages/Sellpoint/Gallery/script.js